/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef } from 'react'; // we need this to make JSX
import { Grid } from '@mui/material';
import { useHistory } from 'react-router';
import moment from 'moment';
import { Logger } from '../../../../libs/utils/logger';
import HttpClient from '../../../../libs/utils/httpClient';
import { IFileInfo } from '../../../Data/FxAgreementLinkCard';
import { convertToPhoneRequestFormat, convertToPhoneDisplayFormat, updateComponentData, fetchDataFromState, updateComponentParams, callAPI, Method, getLastFourDigits, isNullOrUndefined, kycSignupFormValidator } from '../../../Utils/CommonBaseClass';
import { ReviewAndSubmitSignup } from '../Common/ReviewAndSubmitSignup';
import { ICardData } from '../Common/ReviewInfoCard';
import { SignUpLeftBar } from './SignUpLeftBar';
import { SignUpIndividualDetails, SignUpIndividualDetailsRef } from './SignUpIndividualDetails';
import { getCustomerUrl, processAPIResponse, pushGTM, useIsMobileOrTabletScreen } from '../../../../libs/utils/utils';
import { getKey, removeCookieCustom, setKey } from '../../../../libs/utils/storageManager';
import { RegisterComponent } from '../../../../libs/saga/dataSaga';
import FxSnackBar from '../../../Utils/fx-snack-bar';
import { useDispatch, useSelector } from 'react-redux';
import { setLocalStorage} from '../../../../libs/utils/cacheHandler';

import { ReactComponent as ShieldSignupLeftpanel } from '../../../../assets/svg/signup/shield-signup-leftpanel.svg';


const httpClient = HttpClient.getClient();

/**
 * Component: Signup individual
 * Usage: User signup page
 */

Logger.debug("SignUp.tsx", "SignUp initializing")

export const SignUpIndividual: React.FC<any> = React.memo(
    (props) => {
        let context : any;
        ({ context, props } = RegisterComponent(props));
        const { isLoading, step, paymentIdDetailReq, isUpdateContactRequest, initialIndData   } = props;
        const history = useHistory();
        const dispatch = useDispatch();
        const isSmallScreen = useIsMobileOrTabletScreen();
        const childRef = useRef<SignUpIndividualDetailsRef>(null);

        
        /**
         * Useeffect hook resets the parameters
         */
        useEffect(() => {
            updateComponentParams(dispatch, props.id, { isLoading: false, step: 1, formReq: undefined, individualData: undefined, paymentIdDetailData: undefined, paymentIdDetailReq: undefined,  isUpdateContactRequest: false,  initialIndData: false })
        },[dispatch,props.id,])



        /**
         * Method fetches data from the state
         */
        const individualState = useSelector((state: any) =>
            fetchDataFromState(state, 'customer-kyc-individual-data')
        );

        /**
        checking customer info is present on the customer get api or not.If data is present then calling method 'setInitialData' to prepolutae the information
         */
        useEffect(() => {
            if(context?.data?.body){
                setInitialData();
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },[context?.data?.body])
        /**
         * Deep copy function to create a copy of the object and its nested properties
         * @param obj : object
         * @returns 
         */
        function deepCopy(obj: any) {
            if (typeof obj !== 'object' || obj === null) {
                return obj; // Return the value if it's not an object
            }

            const newObj: any = Array.isArray(obj) ? [] : {}; // Determine if it's an array or object

            for (const key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                newObj[key] = deepCopy(obj[key]); // Recursively copy nested properties
                }
            }

            return newObj;
            }
        /**
         * method used to set data on form while page loading
         */
        const setInitialData= ()=> {
            const data = getIndividualDetailsDataFromApi(context?.data?.body?.individual ? context.data.body.individual:[]);
            const individualDetailsData = individualState?.data?.individualData || data;
            const formReqCopy = signUpIndividual({ details: individualState?.data?.individualData || data })
            const individualStateCopy = deepCopy(individualState?.data);
            valiIdateIndividualForm(individualDetailsData);
            let individualObj;
            if(individualStateCopy && individualDetailsData){
                individualStateCopy['individualDetailsData'] = individualDetailsData;
            }
            else{
                individualObj = { individualData: individualDetailsData  }
            }
            updateComponentData(dispatch, 'customer-kyc-individual-data', { ...individualStateCopy || individualObj })

            updateComponentParams(dispatch, props.id, { individualData: individualDetailsData, initialIndData: true, formReq: formReqCopy  })

        }

    /**
     * Validates the individual data against required fields and updates the form validation status.
     * @param individualDetailsData {Object} The primary owner data to be validated.
     */
        const valiIdateIndividualForm = (individualDetailsData: any,) => {
            const taxIdentifier = individualDetailsData?.ssn ? 'ssn' : 'itin';
            const secondaryIdentificationType =
            individualDetailsData?.secondaryIdentificationType === 'DRIVER_LICENSE'
                    ? ['secondaryIdentificationId', 'secondaryIdentificationIssuanceState']
                    : individualDetailsData?.secondaryIdentificationType === 'PASSPORT'
                        ? ['secondaryIdentificationIssuance', 'secondaryIdentificationId']
                         :individualDetailsData?.secondaryIdentificationType === 'ALIEN_REGISTRATION_CARD'?['secondaryIdentificationId', 'secondaryIdentificationIssuance']:[]
            const primaryOwnerRequiredFields = ['addressLine1', 'city', 'dob', taxIdentifier, ...secondaryIdentificationType, 'email', 'firstName', 'lastName', 'mobilePhone', 'state', 'zip'];
            kycSignupFormValidator(individualDetailsData, primaryOwnerRequiredFields, 'signupIndividualDetailForm');
        }
       
        /**
         * This method used to set individual customer details as the format of form data
         */
        function getIndividualDetailsDataFromApi(data: any) {
            let _mailingAddress: any = data.mailingAddress;
            _mailingAddress = _mailingAddress ? _mailingAddress[0] : {};
            let _secondaryIdentification= data?.secondaryIdentification ;
            return  {
                "email": data['email'],
                "mobilePhone": convertToPhoneDisplayFormat(data['mobilePhone']),
                "firstName": data['firstName'],
                "lastName": data['lastName'],
                "middleName": data['middleName'] ? data['middleName'] : '',
                "dob": data['dob'],
                "ssn": data?.ssn || data?.last4ssn || '',
                "itin": data?.taxIdentification?.id || data?.taxIdentification?.idLast4 || '', 
                "address_id": _mailingAddress.id ? _mailingAddress.id : '',
                "addressLine1": _mailingAddress['addressLine1'],
                "addressLine2": _mailingAddress['addressLine2'] ? _mailingAddress['addressLine2'] : '',
                "city": _mailingAddress['city'],
                "state": _mailingAddress['state'],
                "zip": _mailingAddress['zip'],
                "mobilePhone-select": "+91",
                "secondaryIdentificationId":_secondaryIdentification?.id || '',
                "secondaryIdentificationType":_secondaryIdentification?.type || '',
                "secondaryIdentificationIssuanceState":_secondaryIdentification?.stateOfIssuance|| '',
                "secondaryIdentificationIssuance":_secondaryIdentification?.countryOfIssuance|| '',
                "expiryDate":_secondaryIdentification?.expiryDate || null,
            }
        }

        // Method handles the onsubmit event of the individual details form
        const getIndividualDetails = async (data: any, callback:any) => {
            const mailingAddress = await getMailingAddress();
            const mailingAddressId = mailingAddress?.individual?.mailingAddress?.[0]?.id;
            const individualStateCopy = {...individualState?.data}
            individualStateCopy['individualData'] = data;
            const formReqCopy = signUpIndividual({ details: data })           

            const req ={...formReqCopy.customer};

            if (mailingAddressId && req?.individual?.mailingAddress && req?.individual?.mailingAddress.length > 0) {
                const mailingAddress = [...req.individual.mailingAddress];
                mailingAddress[0] = { ...mailingAddress[0], id: mailingAddressId };
                req.individual.mailingAddress = mailingAddress;
            }

            const url:any="customer/id/" + getKey('customerId');
            let status = await callAPI(url, Method.POST, req)
            status = processAPIResponse(status);

            callback()
            if (status.status) {
                    updateComponentParams(dispatch, props.id, { individualData: data, step: 3, formReq: formReqCopy })
    
                updateComponentData(dispatch, 'customer-kyc-individual-data', { ...individualStateCopy })
            }
            else {
                //api  failed
                FxSnackBar.show({
                    text: status.message,
                });
            }
        }
        
        /**
         * Fetches the mailing address (location list) for a customer.
         *
         * Makes an HTTP GET request to the customer endpoint and returns the response data.
         *
         * @returns location list data.
         */
        const getMailingAddress = async () => {
            const locationList: any = await httpClient.get(getCustomerUrl('')).then((response) => response.data)
            return locationList;
        }

        // Method transforming request
        function signUpIndividual(data: any) {
            const details: any = data.details ? data.details : {};
            const address: any = {
                addressLine1: details['addressLine1'],
                addressLine2: details['addressLine2'] ? details['addressLine2'] : '',
                city: details['city'],
                state: details['state'],
                zip: details['zip'],
                isPrimary: true
            };
            if(details.addressLine2 === undefined || details.addressLine2 === ''){
                delete address['addressLine2']
            }
            if(details['address_id']){
                address['id'] = details['address_id'];
            }
            const req:any = {
                customer: {
                    "type": "INDIVIDUAL",
                    "isKycUpdate": true,
                    "individual": {
                        "firstName": details.firstName,
                        "middleName": details.middleName,
                        "lastName": details.lastName,
                        // Add SSN or ITIN in the request only if respective value is present in details object.
                        ...(details?.ssn?.length > 10 && {"ssn": details.ssn}),
                        ...(details?.itin && {
                            "taxIdentification": {
                                "id": details?.itin || '',
                                "type": 'ITIN'
                            }
                        }),
                        "dob": moment(details.dob).format('MM/DD/YYYY'),
                        "email": details.email,
                        "mobilePhone": convertToPhoneRequestFormat(details.mobilePhone),
                        "mailingAddress": [address]
                    },
                }
            }
            if (details?.itin?.length == 4) {
                delete req['customer']['individual']['taxIdentification']
            }

            if(!isNullOrUndefined(details['secondaryIdentificationId'])){
                req['customer']['individual']['secondaryIdentification'] = {};

                if(!isNullOrUndefined(details['expiryDate'])){
                    req["customer"]["individual"]["secondaryIdentification"]["expiryDate"]=details['expiryDate'];
                }
                if(details['secondaryIdentificationType'] === 'DRIVER_LICENSE'){
                    req["customer"]["individual"]["secondaryIdentification"]["type"]=details['secondaryIdentificationType'];
                    req["customer"]["individual"]["secondaryIdentification"]["id"]=details['secondaryIdentificationId'];
                    req["customer"]["individual"]["secondaryIdentification"]["stateOfIssuance"]=details['secondaryIdentificationIssuanceState'];
                }else{
                    req["customer"]["individual"]["secondaryIdentification"]["type"]=details['secondaryIdentificationType'];
                    req["customer"]["individual"]["secondaryIdentification"]["id"]=details['secondaryIdentificationId'];
                    req["customer"]["individual"]["secondaryIdentification"]["countryOfIssuance"]=details['secondaryIdentificationType'] === 'ALIEN_REGISTRATION_CARD' ? 'US' : details['secondaryIdentificationIssuance']
                }
            }

            if(details.middleName === undefined || details.middleName === ''){
                delete req['customer']['individual']['middleName']
            }
            
            return req;
        }
        // Method handles the onsubmit event of the review & submit page
        const handleReviewIndividualSubmit = (req:any) => {
            const customerType ={
                customer:{
                    type: "INDIVIDUAL",
                }
            };

          const linkedDocuments = req?.fileData?.map((file: IFileInfo) => {
            return {
              purpose: 'AUTHORIZATION',
              document: {
                type: file?.fileType,
                name: file?.fileType === 'RATE_CARD' ? 'RATE_CARD.pdf' : 'KYC_AGREEMENT.pdf',
                base64encodedContent: file?.base64
              }
            }
          })

            const request = {...customerType, ...req};
            let accountData: any = {
                "isCustomerOwned": true,
                "linkedDocument": linkedDocuments
            }
            if(paymentIdDetailReq?.nickname){
                accountData = {
                    ...accountData,
                    "nickName" : paymentIdDetailReq?.nickname
                }
            }

            request['account'] = accountData
            reviewIndividualSubmitRequest(request)
        }

        async function reviewIndividualSubmitRequest(req:any){
            let status:any = false;
            if(isUpdateContactRequest){
                status = true;
            }

            if(!status){
                status = await transformRequest(req)
            }

        }

        // Method transforms the request from various pages for api call
        async function transformRequest(req: any) {
            updateComponentParams(dispatch, props.id, { isLoading: true })
            delete req['privacyPolicyAccepted'];
            delete req['fileData'];
            delete req['accountNickname'];
            let status: any;
            status = await updateCustomer(req);
            status = processAPIResponse(status)
            if (status.status) {
                removeCookieCustom('customerKycData')
                // configuring gtm for kyc successful submit
                    const gtmData ={
                        event:"userKycSuccessTrigger",
                        "userEmail": getKey('email'),
                        "userType": "INDIVIDUAL"
                    }
                    pushGTM(gtmData)
                setKey('kycPending','true');
                    updateComponentParams(dispatch, props.id, { isLoading: false, isUpdateContactRequest: true })
                    setLocalStorage('signUpFlow',undefined);
                    history.push('/home');
            }
            else {
                setLocalStorage('signUpFlow',undefined);
                //api  failed
                updateComponentParams(dispatch, props.id, { isLoading: false })
                FxSnackBar.show({
                    text: status.message,
                });
                return false;
            }
        }

        /**
        * API call function
        * @param req :request
        * @returns
        */
        async function updateCustomer(req: any) {
            try {
                const data: any = await httpClient.post(getCustomerUrl('/onboard',false), req).then(response => {
                    return response
                })
                    .catch((error) => {
                        return { ...error };
                    })
                return data;
            } catch (err) {
                return err;
            }
        }

        // Method handles the going back from review screen to payment ppi screen
        const handleReview = (step?: number) => {
            

          if(step){
            updateComponentParams(dispatch, props.id, { step })
          } else {
            let _step: any;
              _step = 1;
            updateComponentParams(dispatch, props.id, { step: _step })
          }
        }

        /**
         * Handles sidebar review logic.
         * Submits form via childRef and updates form validity state accordingly.
         * Then proceeds with the standard review handling.
         */
        const sideBarHandleReview = (step?: number) => {
            handleDataSaveOnSectionChange();
            handleReview(step);
        }

        /**
         * This method handles the data save on section change
         */
        const handleDataSaveOnSectionChange = async () => {
            if(props?.step === 1){
                const feedback =  await childRef.current?.submitForm();
                if(feedback && feedback.success===true){
                    setKey('signupIndividualDetailForm','valid');
                }else{
                    setKey('signupIndividualDetailForm','invalid')
                }
            }
        }

        // Method handles the click event of menu bar
        const handleMenuClick = (step: any) => {
            updateComponentParams(dispatch, props.id, { step })

        }

      const individualData = individualState?.data?.individualData || {};

        // Individual details for the review screen
        const ssn = getLastFourDigits(individualData.ssn);
        const itin = getLastFourDigits(individualData.itin);
      const basicIndividualInfo: ICardData = {
        header: 'Individual Customer Info',
        items: [{
          name: `${individualData.firstName ?? ''} ${individualData.middleName ?? ''} ${individualData.lastName ?? ''}`,
          data: {
            ein: {
              title: 'EIN:',
              value: individualData.ein || ''
            },
            ...(itin ? { itin: { title: 'ITIN', value: `${itin ? '*' + itin : ''}` } } :
            { ssn: { title: 'SSN', value: `${ssn ? '*' + ssn : ''}` } }),
            address: {
              value: `${individualData.addressLine1 || ''} ${individualData.addressLine2 || ''}${individualData.city ? ', ' + individualData.city : ''}${individualData.state ? ', ' + individualData.state : ''}${individualData.zip ? ', Zip - ' + individualData.zip : ''}`
            },
            email: {
              value: individualData.email || ''
            }
          }
        }]
      }



      // Review details for the review screen
      const reviewDetails = [
        { info: basicIndividualInfo, step: 1 },
      ]

        return (
            <Grid item xs={12} container direction="row"  className='fx-form-grid'>
                {!isSmallScreen && <Grid item xs={3} sm={4} md={3} container direction="row" alignContent="flex-start"    className ="fx-login-promo-parent">
                    <SignUpLeftBar activeMenu={step} goBackClick={sideBarHandleReview} onClick={handleMenuClick} data={individualState?.data?.individualData} />
                </Grid>}
                {isSmallScreen && <Grid item xs={12} md={12}  container direction="row" alignContent="flex-start" sm={12}   className ="fx-login-promo-parent">
                    <SignUpLeftBar activeMenu={step} onClick={handleMenuClick} data={individualState?.data?.individualData} />
                </Grid>}
                {initialIndData && individualState?.data?.individualData && <Grid className={`left-sidebar-signup ${step === 1 ? 'active' : ''}`} item xs={12} sm={isSmallScreen?undefined:8} md={isSmallScreen?undefined:9} container direction="row">
                    <SignUpIndividualDetails id='fx-signup-individual-details' ref={childRef}  onSubmit={getIndividualDetails} data={individualState?.data?.individualData} />
                </Grid >}


                {step === 3 && <Grid item xs={12} sm={isSmallScreen?12:8} md={isSmallScreen?12:9} container direction="row" alignContent="flex-start">
                    <ReviewAndSubmitSignup reviewDetails={reviewDetails} goBackClick={handleReview} onSubmit={handleReviewIndividualSubmit} loading={isLoading} />
                </Grid >}
            </Grid >
        );
    });
